import React from 'react';
import { Button, Form } from 'antd';
import Table from 'components/Table';
import RemoveInput from 'components/RemoveInput';
import { PlusOutlined } from '@ant-design/icons';
import { ALL_SETTINGS, SETTING_TYPES_COLUMN_WIDTH } from 'shared/constants/settings';
import DrawerForm from 'components/DrawerForm';
import SettingLabel from './SettingLabel';
import EditSettingValue from './EditSettingValue';

const ArraySettingDrawer = ({ arraySetting, onCancel, onDone, onFormSubmit }) => {
  const settings = arraySetting?.setting?.settings;
  const columns = settings?.map(settingKey => {
    const setting = ALL_SETTINGS[settingKey];

    return {
      dataIndex: settingKey,
      title: <SettingLabel setting={settingKey} />,
      render: (_, field) => (
        <EditSettingValue namePath={[field.name]} settingKey={settingKey} setting={setting} />
      ),
      width: Math.min(1200, SETTING_TYPES_COLUMN_WIDTH[setting.type || 200] + 100),
    };
  });

  const width = columns?.reduce((acc, c) => acc + c.width, 0);

  const initialValues = arraySetting ? {
    settings: {
      [arraySetting.key]: arraySetting.value,
    },
  } : {};

  return (
    <DrawerForm title={<SettingLabel setting={arraySetting?.key} />} open={!!arraySetting} onCancel={onCancel} onDone={onDone} onSubmit={onFormSubmit} initialValues={initialValues} formReset={arraySetting} width={width}>
      {arraySetting ? (
        <Form.List name={['settings', arraySetting.key]}>
          {(fields, { add, remove, move }) => (
            <>
              <Table
                emptyMessage="Add settings below"
                pagination={false}
                sortable
                onSortEnd={({ oldIndex, newIndex }) => move(oldIndex, newIndex)}
                columns={columns}
                dataSource={fields}
                rowKey="key"
                actions={field => (
                  <RemoveInput onRemove={() => remove(field.name)} />
                )}
              />
              <Button type="primary" block onClick={() => add({})} icon={<PlusOutlined />}>Add</Button>
            </>
          )}
        </Form.List>
      ) : null}
    </DrawerForm>
  );
};

export default ArraySettingDrawer;
